import { render, staticRenderFns } from "./M0301ScanRecordList.vue?vue&type=template&id=08cd74c2&scoped=true&"
import script from "./M0301ScanRecordList.vue?vue&type=script&lang=js&"
export * from "./M0301ScanRecordList.vue?vue&type=script&lang=js&"
import style0 from "./M0301ScanRecordList.vue?vue&type=style&index=0&id=08cd74c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd74c2",
  null
  
)

/* custom blocks */
import block0 from "./locales/en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Facc-web%2Fadmin%2Fsrc%2Fcomponents%2Ffunctions%2FAdmin%2FM0301ScanRecord%2FM0301ScanRecordList.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./locales/zhHant.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Facc-web%2Fadmin%2Fsrc%2Fcomponents%2Ffunctions%2FAdmin%2FM0301ScanRecord%2FM0301ScanRecordList.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VDataTable,VIcon})
